import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FlexView, Row, Button } from '@cuemath/comps';
import { openModal } from 'actions/modal';
import { MODAL_FORM } from 'constants/form';
import { UPLOAD_DISPATCH_TEXT } from 'constants/workbook-management';
import MODAL from 'constants/modal';

const FullFlexView = styled(FlexView)`
  width: 100%;
`;

const Head = styled(Row)`
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
`;

class UploadDispatch extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      openModal: PropTypes.func.isRequired,
    }),
  };

  onClickUploadDispatch = heading => {
    const { actions } = this.props;

    actions.openModal(
      MODAL_FORM.WORKBOOK_DISPATCHED_UPLOAD_MODAL,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      {
        heading,
      },
    );
  };

  render() {
    return (
      <FullFlexView justifyContent="center" alignItems="center">
        <Head alignItems="center" justifyContent="flex-start">
          <Button
            label={UPLOAD_DISPATCH_TEXT}
            onClick={() => this.onClickUploadDispatch(UPLOAD_DISPATCH_TEXT)}
          />
        </Head>
      </FullFlexView>
    );
  }
}

export default connect(null, dispatch => ({
  actions: bindActionCreators(
    {
      openModal,
    },
    dispatch,
  ),
}))(UploadDispatch);
